"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateManager = exports.StateManager = void 0;
var react_1 = require("react");
var rxjs_1 = require("rxjs");
var StateManager = /** @class */ (function () {
    function StateManager(reducer, initialState) {
        this._initialState = initialState;
        this._state$ = new rxjs_1.BehaviorSubject(initialState);
        this.state$ = this._state$.asObservable();
        this._reducer = reducer;
    }
    StateManager.prototype.dispatch = function (action) {
        var currentState = this._state$.getValue();
        var newState = this._reducer(currentState, action);
        this._state$.next(newState);
    };
    StateManager.prototype.getState = function () {
        return __assign({}, this._state$.getValue());
    };
    return StateManager;
}());
exports.StateManager = StateManager;
function useStateManager(manager) {
    var _a = __read((0, react_1.useState)(manager.getState()), 2), state = _a[0], setState = _a[1];
    (0, react_1.useEffect)(function () {
        var sub = manager.state$.subscribe(function (newState) { return setState(newState); });
        return function () { return sub.unsubscribe(); };
    }, [manager]);
    var dispatch = (0, react_1.useCallback)(function (action) { return manager.dispatch(action); }, [
        manager,
    ]);
    return [state, dispatch];
}
exports.useStateManager = useStateManager;
//# sourceMappingURL=StateManager.js.map